export default __webpack_public_path__ + "static/media/na.d113159b.svg";